<template>
    <v-col :cols="cols" class="ma-0 pa-0">
        <div class="form-group">
            <label v-if="field.outerLabel"
                ><span class="outlabel">{{ field.outerLabel }}</span></label
            >

            <v-text-field
                class="field"
                dense
                v-model="field.text"
                :label="field.label"
                :placeholder="field.placeholder"
                outlined
                :rules="field.form ? nameRules : noRules"
                v-mask="mask"
                :tipo="field.tipo"
            ></v-text-field>
        </div>
    </v-col>
</template>

<script>
export default {
    name: 'txt',
    props: ['fields', 'cols'],
    data() {
        return {
            field: this.fields,
            nameRules: [v => !!v || 'Campo obrigatório'],
            mask: this.masked(),
            noRules: []
        }
    },
    methods: {
        masked() {
            if (this.fields.tipo === 'volt') return '### V'
            if (this.fields.tipo === 'caixa') return '## x ## x ## cm'
        }
    },
    created() {
        this.$emit('fields', this.field)
    },
    watch: {
        fields(val) {
            this.field = val
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,400;1,300&display=swap');

.v-text-field >>> label {
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
}
.v-text-field >>> :placeholder-shown {
    font-family: Inter;
    font-size: 14px;
    font-weight: 545;
}

::v-deep.v-input--dense > .v-input__control > .v-input__slot {
    margin-bottom: 0px !important;
    border-radius: 5px;
}
::v-deep.v-input:hover .v-label {
    color: #0077c8 !important;
}
::v-deep.v-text-field:hover fieldset,
.v-text-field.v-input--has-state fieldset {
    border: 1px solid #0077c8;
}

::v-deep.v-text-field:hover fieldset,
.v-text-field.v-input--has-state fieldset {
    border: 1px solid #0077c8;
}
.outlabel {
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
}
</style>
